import React from "react";
import { Overline } from "./Overline";
import { images } from "../data/content";
export function About() {
  return <section id="safti" className="scroll-mt-20 py-24 md:py-36" data-id="element-1" data-mp="2ps9v5brmnmgm">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 md:px-10 lg:grid-cols-12 lg:gap-10" data-id="element-2" data-mp="2ttbvjvxa64k6">
        <div className="lg:col-span-5" data-id="element-3" data-mp="2yrwuzt4pkk7k">
          <img src={images.stage} alt="Jérémy Couput sur scène, micro en main, lors d'une remise de trophée SAFTI" className="aspect-[4/5] w-full object-cover" data-id="element-4" data-mp="2ytq6pmu6humf" />
        </div>

        <div className="flex flex-col justify-between lg:col-span-6 lg:col-start-7" data-id="element-5" data-mp="38o8cqyn2i29e">
          <div data-id="element-6" data-mp="3dhurqxgpei8d">
            <Overline data-id="element-7" data-mp="3dj5s0naxx7uq">Qui suis-je</Overline>
            <h2 className="mt-6 text-[40px] font-semibold leading-[1] tracking-[-0.035em] md:text-[64px]" data-id="element-8" data-mp="3hiwggkczvbw3">
              Un réseau national, <span className="font-serif font-normal italic text-brand" data-id="element-9" data-mp="3mjaq26u8utw8">une équipe</span> à taille humaine.
            </h2>
            <div className="mt-8 max-w-xl space-y-5 text-[17px] leading-relaxed text-ink-muted" data-id="element-10" data-mp="3req4azw5yrt6">
              <p data-id="element-11" data-mp="2lp4hysjceujz">
                Je suis Jérémy Couput, conseiller et leader de la SAFTI Infiny Team. Après des années sur le terrain, j'ai fait le choix de
                transmettre : aider des personnes motivées à réussir dans l'immobilier, à leur rythme et à leur façon.
              </p>
              <p data-id="element-12" data-mp="27tiwuwg8cuwu">
                SAFTI vous apporte la force d'un réseau, ses outils et sa notoriété. Notre équipe vous apporte le reste : de l'écoute, des
                méthodes éprouvées et une vraie dynamique collective.
              </p>
            </div>
          </div>

          <figure className="mt-14 border-t border-paper-line pt-8" data-id="element-13" data-mp="2vnu0mnj2cj1a">
            <blockquote className="font-serif text-[28px] italic leading-snug text-ink md:text-[34px]" data-id="element-14" data-mp="2qr3mw6uqdzj1">
              « Personne ne réussit seul. Mon rôle, c'est que chaque nouveau conseiller signe son premier mandat en confiance. »
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-4" data-id="element-15" data-mp="3jd4t7hq9f74c">
              <img src={images.beach} alt="" className="h-12 w-12 rounded-full object-cover object-top" data-id="element-16" data-mp="67560ufm2adw" />
              <span className="text-[14px]" data-id="element-17" data-mp="b4f3mxd5lsct">
                <span className="block font-semibold" data-id="element-18" data-mp="3tj621waenz3w">Jérémy Couput</span>
                <span className="text-ink-muted" data-id="element-19" data-mp="3tgtkvlch1srw">Leader SAFTI Infiny Team</span>
              </span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}